export const API_HOST = 'https://api3.ruptly.tv';
export const VOD_HOST = 'https://www.ruptly.tv';
export const LIVE_HOST = 'https://www.ruptly.tv';
export const STATIC_HOST = 'https://video.ruptly.tv';
export const STRIPE_API_KEY = 'pk_live_zH2KMBt5Es7OnrPaesBaONAO';
export const COMMON_DOMAIN = '.ruptly.tv';
export const FB_APP_ID = '127697134666936';
export const WS_URI = "wss://api3.ruptly.tv/cable";
export const PLAUSIBLE_SCRIPT_PATH = 'storage.ruptly.tv';
